
import { Card } from "antd";

export default function PointsRules() {
  return (
    <Card>
          <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-8 text-center">积分规则</h1>
      
      {/* 基本规定 */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">一、基本规定</h2>
        <ol className="list-decimal pl-5 space-y-3 text-gray-700">
          <li>{`鼎坚传动会员消费，即可按照积分规则明确的计算方式累计积分，并可根据鼎坚传动规定兑换相应的实物礼品、服务等(以下统称"积分礼品")。`}</li>
          <li>{`鼎坚传动会员如有下述情形之一，鼎坚传动有权取消其参加积分活动资格:涉利用虚假交易获取积分(包括为他使用恶意手段刷积分行为)、所持鼎坚传动会员会被停用或被制使用、自行注销、有违期大额行为、违反《鼎坚传动用户协议》、违反《鼎坚传动章程》或本积分规则及其他相关规定的。`}</li>
          <li>鼎坚传动有权要求消费人提供消费交易凭票、购买凭证等材料，以查实交易真实性;如消费人无法提交相关材料，安百商城有权不予兑换。一旦查实消费人为虚假交易获取积分兑换商品或有违期款行为的，以及违反法律法规及监管规章或违反行相关约定规定的，鼎坚传动有权采取结积分、积分清零、冻结会员使用等措施，并保留进一步追究的权利;如前述行为可能构成犯罪的，鼎坚传动有权向公安机关报案并向司法机关提供相关资料和信息。</li>
          <li>积分为鼎坚传动对会员消费的回馈项目，在兑换取得积分礼品前并不构成会员资产，积分不可转让给其他会员或任何第三人，任何转让对鼎坚传动均不产生效力。</li>
        </ol>
      </section>

      {/* 关于积分 */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">关于积分</h2>
        <p className="text-gray-700 mb-4">
          积分是用户在鼎坚传动电商平台(www.XXXXXX.com)进行交易、户充值、活动参与等相关活动后给予的回馈性奖，可累积，且在兑换期内有效。积分不可提现与转让，仅可在鼎坚传动电商平台积分商城使用,次年6月30日自动清零。
        </p>
      </section>

      {/* 如何使用 */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">如何使用</h2>
        <ol className="list-decimal pl-5 space-y-3 text-gray-700">
          <li>{`商城兑换:用户可去"积分商城"兑好礼，依照积分兑换标准兑换相应礼品。`}</li>
          <li>平台活动:鼎坚传动将不定期举行线上积分兑换活动。</li>
        </ol>
      </section>

      {/* 签到获得 */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">签到获得</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-3 text-left">任务获得积分方式</th>
                <th className="border p-3 text-left">获得积分值(分)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-3">每日签到(一天限1次)</td>
                <td className="border p-3">10</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      {/* 消费获得 */}
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4">消费获得</h2>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border p-3 text-left">消费获得积分方式</th>
                <th className="border p-3 text-left">获得积分值(分)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border p-3">线上消费，不满10元不累计积分</td>
                <td className="border p-3">实际消费金额*10一积分回数率(不含运费)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
    </Card>

  )
}